import { render } from "./2fa.vue?vue&type=template&id=dde31a22"
import script from "./2fa.vue?vue&type=script&lang=js"
export * from "./2fa.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/auth/2fa.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dde31a22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dde31a22', __exports__)) {
    console.log('reload')
    api.reload('dde31a22', __exports__)
  }
  
  module.hot.accept("./2fa.vue?vue&type=template&id=dde31a22", () => {
    console.log('re-render')
    api.rerender('dde31a22', render)
  })

}


export default __exports__